import { render } from "./LoginHolder.vue?vue&type=template&id=4ba13f10"
const script = {}

import "./LoginHolder.vue?vue&type=style&index=0&id=4ba13f10&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__